// extracted by mini-css-extract-plugin
export default {"container":"UserData_container__3OwAs","inProfile":"UserData_inProfile__hyKzR","username":"UserData_username__8DtfN","tag":"UserData_tag__R37Ca"};